import {Inject, Injectable, LOCALE_ID, Optional} from '@angular/core';
import {environment} from '../environments/environment';
import {HttpHeaders} from '@angular/common/http';
import {SuperService} from './super.service';
import {TranslateService} from '@ngx-translate/core';
import {WINDOW} from "./window-provider";

@Injectable({
    providedIn: 'root'
})
export class BaseService {


    public apiURL;
    public baseAPI;
    public baseAPI2;
    public baseCatalogUrl;
    public websiteId;
    public currentLang;
    public storeId;
    public searchBaseLink;
    public storeview;

    // public catalogURL = environment.catalogURL;

    // public registrationURL = environment.registrationURL;

    // public isEmailAvailableURL = environment.isEmailAvailableURL;

    constructor() {


        this.apiURL = environment.baseAPI2;
        this.baseAPI = this.loadCatalogAPILink();
        this.baseAPI2 = environment.baseAPI2;
        this.baseCatalogUrl = environment.baseCatalogUrl;
        this.websiteId = environment.website_id;
        this.currentLang = this.getCurrentLang();
        this.searchBaseLink = environment.baseCatalogUrl + '/rest/all/V1/';


    }


    public loadCatalogAPILink(domain = ""): string {

        let apiurl = '';
        domain = document.location.hostname;

        if(domain == "" || domain == "localhost" || domain == "alarabiya.com.kw") {
            switch (this.getCurrentLang()) {
                case 'ar':
                    this.currentLang = 'ar';
                    apiurl = environment.baseCatalogUrl + '/rest/ar/V1/';
                    this.storeId = 2;
                    this.storeview= 'ar';
                    break;
                default:
                    this.currentLang = 'en';
                    this.storeview= 'default';
                    apiurl = environment.baseCatalogUrl + '/rest/default/V1/';
                    this.storeId = 1;
            }
        }else if(domain == "sa.alarabiya.site")
        {
            switch (this.getCurrentLang()) {
                case 'ar':
                    this.currentLang = 'ar';
                    this.storeview= 'storeview_sa_ar';
                    apiurl = environment.baseCatalogUrl + '/rest/storeview_sa_ar/V1/';
                    this.storeId = 3;
                    break;
                default:
                    this.currentLang = 'en';
                    this.storeview= 'storeview_sa';
                    apiurl = environment.baseCatalogUrl + '/rest/storeview_sa/V1/';
                    this.storeId = 3;
            }
        }
        this.baseAPI = apiurl;

        return apiurl;

    }

    getCurrentLang(): string | undefined {

        const path = window.location.pathname.replace(window.location.href, '');
        // console.log('pathname');
        // console.log(window.location.pathname);
        // console.log('href');
        // console.log(window.location.href);
        //
        //
        // console.log('the path');
        // console.log(path);

        // console.log(path.includes('ar/'));

        if (path.includes('ar/')) {
            return 'ar';
        } else if (path.includes('en')) {
            return 'en';
        } else {
            return 'en';
        }
        // const parts = path.split('/');
        // if (parts.length < 2)
        //     // The path does not contain a language code
        // return "";
        // return parts[1];

    }


}
